export default __webpack_public_path__ + "static/media/P303 zu P305.ae893c13.mp3";